// Third-party
import React from 'react';
import classNames from 'classnames';
import DOMPurify from 'dompurify';

// Components
import NoDataCell from './NoDataCell';
import ComparisonItem from '@/types/comparison-item';

type Props = {
  value?: string;
  className?: string;
  onClick?: () => void;
  id?: string;
  disclaimer?: string;
  item?: ComparisonItem;
};

const HTMLCell: React.FunctionComponent<Props> = ({ value, className, disclaimer, item, onClick, id }: Props) => {
  if (value == null) {
    return <NoDataCell disclaimerKey={disclaimer} item={item} onClick={onClick} id={id} />;
  }

  return (
    <div className={classNames('cell html-cell', className)} onClick={onClick} id={id ? `cell-${id}` : undefined}>
      {value && <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value) }} />}
    </div>
  );
};

export default HTMLCell;
